import { useState } from "react";
import Dropzone from "../Components/Dropzone";
import ErrorBanner from "../Components/ErrorBanner";
import JobList from "../Components/JobList";
import PrivacyNotice from "../Components/PrivacyNotice";
import { deleteJob, uploadJob } from "../api/jobs";
import { extractApiErrorMessage } from "../api/client";
import { useJobs } from "../Hooks/useJobs";
import { useSession } from "../Hooks/useSession";

export default function Home() {
    const { error: sessionError, ready } = useSession();
    const { jobs, loading, error: jobsError, addJob, removeJob } = useJobs(ready);

    const [uploading, setUploading] = useState(false);
    const [uploadError, setUploadError] = useState<string | null>(null);
    const [deletingId, setDeletingId] = useState<string | null>(null);

    const handleFileSelected = async (file: File) => {
        setUploading(true);
        setUploadError(null);
        try {
            const job = await uploadJob(file);
            addJob(job);
        } catch (err) {
            setUploadError(extractApiErrorMessage(err, "Impossibile caricare il file. Riprova."));
        } finally {
            setUploading(false);
        }
    };

    const handleDelete = async (jobId: string) => {
        setDeletingId(jobId);
        try {
            await deleteJob(jobId);
            removeJob(jobId);
        } catch {
            // Non-critical: leave the job visible, the user can retry the removal.
        } finally {
            setDeletingId(null);
        }
    };

    return (
        <div className="space-y-8">
            <section className="space-y-2">
                <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
                    Converti i tuoi PDF in Markdown
                </h1>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                    Carica un file PDF: verrà scansionato, convertito in background con Docling e
                    reso disponibile per il download in formato Markdown.
                </p>
                <PrivacyNotice />
            </section>

            {sessionError && <ErrorBanner message={sessionError} />}

            <section className="space-y-3">
                <Dropzone onFileSelected={handleFileSelected} uploading={uploading} disabled={!ready} />
                {uploadError && <ErrorBanner message={uploadError} />}
            </section>

            <section className="space-y-3">
                <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                    Le tue conversioni
                </h2>
                {jobsError && <ErrorBanner message={jobsError} />}
                <JobList jobs={jobs} loading={loading} onDelete={handleDelete} deletingId={deletingId} />
            </section>
        </div>
    );
}
